// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var SignupCompleteController = function ($location, gettextCatalog) {
    gettextCatalog.currentLanguage = $location.$$search.language || 'de';
}
SignupCompleteController.$inject = ['$location', 'gettextCatalog'];
